// Olympe
import { useProperty } from '@olympeio/core';

// Rxjs
import { tap, combineLatest, throttleTime } from 'rxjs';

/**
 * Init the bounding box
 * @param {!BrickContext} $ 
 */
export function initBox($) {
    // Listen to the component position and size
    combineLatest([$.observe('Width'), $.observe('Height')])

        // Debounce the changes to avoid to many rerendering
        .pipe(throttleTime(100, undefined, { leading: true, trailing: true }))

        // Set the final box
        .pipe(tap(([width, height]) => $.set('_rgBox', { width, height })))

        // Run 
        .subscribe();
}

/**
 * @param {!BrickContext}
 * @return {!*}
 */
export function useBox($) {
    return useProperty($, '_rgBox') ?? {width: $.get('Width'), height: $.get('Height') };
}

